import { defineStore } from 'pinia';
import Vue from 'vue';

import type { SignalRMethodName } from '@/constants/signalr-methods';

import signalrMethods from '@/constants/signalr-methods';

import { projectGet, projectInvestSales } from '@/api/endpoints/projects';

type RoleType = 'borrower' | 'investor' | 'undefined';

export const useProjectStore = defineStore('project', {
  state: () => ({
    role: 'undefined' as RoleType,
    projectId: null as string | null,
    serverData: null as Record<string, any> | null | undefined,
    salesStats: null as Record<string, any> | null | undefined,
    repayScheduleData: null as Record<string, any> | null | undefined,

    abortController: null as AbortController | null,
  }),

  actions: {
    setRole(payload: RoleType) {
      this.role = payload;
    },

    async fetchServerData(projectId: string) {
      if (this.projectId && projectId !== this.projectId) {
        this.serverData = null;
      }

      this.abortController?.abort();
      this.abortController = new AbortController();

      this.projectId = projectId;

      if (this.role !== 'borrower') {
        Vue.http.post(projectInvestSales, { id: projectId, pageSize: 0 })
          .then((wrapper) => {
            this.salesStats = wrapper.data?.response?.stats;
          });
      }

      return Vue.http.post(projectGet, { id: projectId }, { signal: this.abortController!.signal }).then((wrapper) => {
        this.serverData = wrapper.data?.response;
        return wrapper;
      });
    },

    onSignalrEvent({ event, data }: { event: SignalRMethodName, data?: any }) {
      if (event === signalrMethods.earlyPaymentChange) {
        const project_id = data?.project_id;
        if (project_id === this.projectId) {
          // FIXME: достаточно топорно, может быть не лучшим UX
          this.fetchServerData(project_id);
        }
      }
    },
  },

  beforeDispose() {
    this.abortController?.abort();
  },
});
